import { useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';

const baseUrl = '/api/v1/authentication';

const preValidateIdp = async (axiosInstance: AxiosInstance, idpHint: string) => {
  const requestBody = JSON.stringify({
    idpHint,
  });
  const response = await axiosInstance.post(`${baseUrl}/preValidateIdp`, requestBody);
  return response.data;
};

export const usePreValidateIdpMutation = () => {
  const { unauthenticatedInstance } = useAxiosClientsContextProvider();
  return useMutation({
    mutationKey: ['preValidateIdpQuery'],
    mutationFn: (idpHint: string) => preValidateIdp(unauthenticatedInstance, idpHint),
  });
};
